import React, { memo } from "react";

import SkeletonPlaceholder from "@/components/molecules/SkeletonPlaceholder";

import { Box } from "@/components/atoms/Box";
import { Stack } from "@/components/atoms/Stack";

/**
 * Available skeleton list types
 */
export type TSkeletonListType =
  | "player"
  | "manage-roster"
  | "manage-users"
  | "manage-invitations"
  | "manage-orgs"
  | "note"
  | "modal-player"
  | "shadow-team"
  | "shadow-team-member"
  | "activity-feed";

/**
 *
 */
interface Props {
  type: TSkeletonListType;
  /**
   * Background color class based on theme
   */
  bgColor: string;
}

/**
 * View component for skeleton loading placeholder in manage screens
 * @param root0 - The component props
 * @param root0.type - Type of skeleton list to display determining layout structure
 * @param root0.bgColor - Background color class based on theme for skeleton elements
 */
const SkeletonManageView = ({ type, bgColor }: Props) => (
  <SkeletonPlaceholder>
    <Stack direction="horizontal" className="items-center gap-3 py-2">
      <Stack className="flex-1 gap-2">
        <Box
          className={`h-9 w-full animate-pulse rounded-none opacity-70 ${bgColor}`}
        />
        {type !== "manage-orgs" && (
          <Box
            className={`h-7 w-4/5 animate-pulse rounded-none opacity-70 ${bgColor}`}
          />
        )}
      </Stack>
      <Stack direction="horizontal" className="items-center gap-2">
        <Box
          className={`${type === "manage-users" ? "w-14" : "w-9"} size-9 animate-pulse rounded-none opacity-70 ${bgColor}`}
        />
        <Box
          className={`${type === "manage-users" ? "w-14" : "w-9"} size-9 animate-pulse rounded-none opacity-70 ${bgColor}`}
        />
      </Stack>
    </Stack>
  </SkeletonPlaceholder>
);

SkeletonManageView.displayName = "SkeletonManageView";

export default memo(SkeletonManageView);
